import { motion } from 'framer-motion';
import React, { FC } from 'react';
import styled from 'styled-components';

import { VerticalScrollBar } from '@portals/scrollbar';
import { FADE_IN_OUT } from '@portals/ui';
import { getStyledThemeColor } from '@portals/utils';

export const TabContainer: FC = ({ children }) => (
  <Container {...FADE_IN_OUT}>
    <VerticalScrollBar>{children}</VerticalScrollBar>
  </Container>
);

const Container = styled(motion.div)`
  height: 100%;
`;

export const ContentWrapper = styled.div`
  padding: 20px 25px;

  label,
  .custom-control-label {
    color: ${getStyledThemeColor('gray600')};
    font-weight: 400;
    font-size: 14px;
  }
`;
